import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';
import { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { EXCLUDE_TYPES } from '../../../constants/reviews';
import { setReviewFilterTag } from '../../../helpers/reviews';
import { IReviewItem } from '../../../interfaces/reviews';
import { GlobalState } from '../../../store';
import { TCreateReviewPageQuery } from '../../../types/router';
import { REVIEW_FIELDS } from '../constants/common';

export const isStepReviewTextFormField = (target: any) =>
  [REVIEW_FIELDS.TEXT, REVIEW_FIELDS.TITLE, REVIEW_FIELDS.USER_NAME, REVIEW_FIELDS.MESSAGE_FOR_COMPANY].includes(
    target,
  );

type TGetTypeParams = {
  serverFilters: GlobalState['filters']['serverFilters'];
  organizationType?: TOrganizationTypes;
  query: TCreateReviewPageQuery;
  productTags: GlobalState['filters']['productsTags'];
};

export const getTag = (params: TGetTypeParams) => {
  const { serverFilters, organizationType, query, productTags } = params;

  const { tag, type, organization, product } = query;

  const filterTags = serverFilters[organizationType]?.tag;
  const allProducts = Object.values(productTags ?? {}).flat();

  let extraParam;

  if (tag && organizationType) {
    extraParam = tag;
  } else if (Object.values(PAGE_TYPE).includes(organization as PAGE_TYPE) && !product) {
    extraParam = organization;
  } else if (allProducts.includes(product)) {
    extraParam = product;
  } else if (!EXCLUDE_TYPES.includes(type)) {
    extraParam = type;
  }

  return extraParam ? setReviewFilterTag(filterTags, extraParam) : '';
};

type TReviewTagParams = TGetTypeParams & {
  review: IReviewItem;
};

export const getServiceFromAllData = ({
  review,
  serverFilters,
  organizationType,
  query,
  productTags,
}: TReviewTagParams): string => {
  // если редактируется отзыв
  if (review?.reviewTag) return review.reviewTag;

  return getTag({ query, serverFilters, productTags, organizationType });
};
